import { Injectable } from '@angular/core';

import { select } from '@ngrx/store';
import { BaseSite, BaseSiteService, SiteContextActions, SiteContextSelectors } from '@spartacus/core';
import { combineLatest, Observable, OperatorFunction } from 'rxjs';
import { filter, map, take, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DpBaseSiteService extends BaseSiteService {
  getAll(): Observable<BaseSite[]> {
    return this.store.pipe(
      select(SiteContextSelectors.getAllBaseSites),
      tap((sites) => {
        if (!sites) {
          this.store.dispatch(new SiteContextActions.LoadBaseSites());
        }
      }),
      filter((sites) => !!sites) as OperatorFunction<BaseSite[] | null, BaseSite[]>,
      take(1)
    );
  }

  getDefault(): Observable<BaseSite | undefined> {
    return combineLatest([this.getActive(), this.getAll()]).pipe(
      map(([activeSiteUid, sites]) => sites.find((site) => site.uid === activeSiteUid))
    );
  }
}
